import { render, staticRenderFns } from "./PageInfoBar.vue?vue&type=template&id=1972e3e4&scoped=true&"
import script from "./PageInfoBar.vue?vue&type=script&lang=ts&"
export * from "./PageInfoBar.vue?vue&type=script&lang=ts&"
import style0 from "./PageInfoBar.vue?vue&type=style&index=0&id=1972e3e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972e3e4",
  null
  
)

export default component.exports